<template>
	<div
		class="product-rating"
		v-if="!hideRating"
		ref="product-rating"
	>
		<TnRating
			:rating="rating"
			size="m"
			label
			v-if="!content.hideRating && rating"
			:count="count"
			href="#details-tab=3"
			@click.prevent="scrollToRatings"
		/>
	</div>
</template>
<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import ECommerceProductMixin from "~/components/ecommerce/ECommerceProductMixin/ECommerceProductMixin.js";
import { mapState } from "vuex";
export default defineNuxtComponent({
	name: "ECommerceProductRating",
	mixins: [GizmoComponentMixin, ECommerceProductMixin],

	computed: {
		...mapState("ecommerce", ["product", "totalDetailsTabs"]),
		rating() {
			return parseFloat(this.eCommerceProduct?.rating?.toFixed(1));
		},
		count() {
			return parseInt(this.eCommerceProduct?.reviewCount);
		},
		hideRating() {
			return !this.rating || this.count < 1 || this.component?.content?.hideRating || false;
		},
	},

	methods: {
		scrollToRatings() {
			if (this.totalDetailsTabs) {
				this.$store.commit("ecommerce/setDetailsTab", this.totalDetailsTabs - 1);
			} else if (this.eCommerceProduct.swapTotalPrice) this.$store.commit("ecommerce/setDetailsTab", 3);
			else this.$store.commit("ecommerce/setDetailsTab", 2);
			document.getElementById("product-details").scrollIntoView({ behavior: "smooth" });
		},
	},
});
</script>
<style lang="scss" scoped></style>
